import React from 'react';
import { useLocation } from 'react-router-dom';
import { CreateDomainFormProps } from './types';
import { Modal, SchemaForm } from '@v2/components';
import { useCreateDomain } from '@v2/hooks';
import { domainSchema, domainFields } from './schema';
import type { DomainFormValues } from './schema';

const CreateDomainForm: React.FC<CreateDomainFormProps> = ({
  onCancel,
  onCompleted,
}) => {
  const location = useLocation();
  const partnerId = new URLSearchParams(location.search).get('partnerId');

  const { createDomain, loading, error: createError } = useCreateDomain();

  const handleSubmit = async (data: DomainFormValues) => {
    if (!partnerId) return;
    const result = await createDomain({
      id: partnerId,
      name: data.domain,
    });
    if (result !== null) {
      onCompleted?.();
    }
  };

  return (
    <Modal isOpen={true} onClose={onCancel} title="New Domain" size="md">
      <SchemaForm
        fields={domainFields}
        schema={domainSchema}
        onSubmit={handleSubmit}
        loading={loading || !partnerId}
        error={createError}
        submitLabel="Submit"
        onCancel={onCancel}
        cancelLabel="Cancel"
      />
    </Modal>
  );
};

export default CreateDomainForm;
